import classes from "./styles.module.css"
import {Box, Button, Dialog, DialogContent, IconButton, Tooltip} from "@mui/material";
import { useState, useEffect } from "react";
import CloseIcon from "@mui/icons-material/Close";
import axios from "axios";
import {path} from "../../../routes";

const RATIO_OPTIONS = ['9:16', '16:9', '4:3'];
const isPortrait = (r) => r === '9:16';
const HOLIDAY_INN_ORG_ID = 'E15F8010-B7EB-4526-A985-F00D517EBF4C';
const RADISSON_BLU_ORG_ID = 'AC9D7FD5-E333-4B1E-9043-4697568313B7';
const VIENNA_HOUSE_ORG_ID = '62BDEE7F-9CE9-41BE-A80C-EF69F045D56C';

const Row_org_device =(props)=>{
    const [data, setData] = useState(props.data);
    const [demoOpen, setDemoOpen] = useState(false);
    // Výchozí podle typu zařízení: Displej = 4:3, Kiosk = 9:16
    const getInitialDemoRatio = () => {
        const deviceGroup = Number(props.data?.device_group);
        return deviceGroup === 1 ? '4:3' : '9:16';
    };
    const [demoRatio, setDemoRatio] = useState(getInitialDemoRatio());
    
    // Aktualizovat data když se změní props
    useEffect(() => {
        setData(props.data);
    }, [props.data]);

const deleteFn = () => {
        if (props.onDeleteRequest) {
            props.onDeleteRequest(props.data);
        } else if (props.delete) {
            props.delete(props.data.id);
        }
    };

    const editFn = () => {
        if (props.onEdit) {
            props.onEdit(data);
        }
    }

    const copyToClipboard = async (text) => {
        try {
            const value = String(text);
            if (navigator.clipboard?.writeText) {
                await navigator.clipboard.writeText(value);
                alert('Link copied to clipboard.');
                return true;
            }
            const ta = document.createElement('textarea');
            ta.value = value;
            ta.setAttribute('readonly', '');
            ta.style.position = 'fixed';
            ta.style.opacity = '0';
            document.body.appendChild(ta);
            ta.select();
            const ok = document.execCommand('copy');
            document.body.removeChild(ta);
            if (ok) {
                alert('Link copied to clipboard.');
            }
            return ok;
        } catch (e) {
            console.error('Copy failed:', e);
            return false;
        }
    };
    const getDisplayBaseUrl = (useAdminPath = false) => {
        if (typeof window === 'undefined') return useAdminPath ? 'https://kiosk.csgcontrols.cz/admin/' : 'https://kiosk.csgcontrols.cz/';
        const origin = (window.location.origin || '').replace(/\/$/, '');
        return useAdminPath ? `${origin}/admin/` : `${origin}/`;
    };

    /** Stejná logika jako v UsersDisplays/Row_display – aby admin i user Holiday Inn viděli stejné URL. */
    const getHolidayInnUrlParams = (rowData) => {
        const has = (v) => v != null && v !== '';
        if (has(rowData.url_id)) {
            const urlId = String(rowData.url_id);
            const urlRoom = has(rowData.url_room) ? String(rowData.url_room) : null;
            // Holiday Inn: krátké URL
            // - id=12 / id=13 musí být BEZ orgID (URL má končit po id)
            // - id=11&room=.. také bez orgID
            // - id=3 (recepce) může mít orgID, ale není nutné (frontend si ho doplní fallbackem)
            const urlOrgID =
                (urlId === '3')
                    ? (has(rowData.url_orgID) ? String(rowData.url_orgID) : HOLIDAY_INN_ORG_ID)
                    : null;
            return { urlId, urlRoom, urlOrgID };
        }
        const desc = (rowData.description || '').toLowerCase().trim();
        const id = rowData.id;
        if (desc.includes('restaurace') && (desc.includes('menu') || !desc.includes('specialit'))) return { urlId: '1', urlRoom: null, urlOrgID: null };
        if (desc.includes('restaurace') && desc.includes('specialit')) return { urlId: '9', urlRoom: null, urlOrgID: null };
        if (desc.includes('recepce') || (desc.includes('obrazovka') && desc.includes('výšku'))) return { urlId: '3', urlRoom: null, urlOrgID: HOLIDAY_INN_ORG_ID };
        if (desc.includes('a - d') || desc.includes('a-d')) return { urlId: '12', urlRoom: null, urlOrgID: null };
        if (desc.includes('e - f') || desc.includes('e-f')) return { urlId: '13', urlRoom: null, urlOrgID: null };
        if (desc.includes('meeting room a') || desc === 'meeting room a') return { urlId: '11', urlRoom: '23', urlOrgID: null };
        if (desc.includes('meeting room b')) return { urlId: '11', urlRoom: '24', urlOrgID: null };
        if (desc.includes('meeting room c')) return { urlId: '11', urlRoom: '25', urlOrgID: null };
        if (desc.includes('meeting room d')) return { urlId: '11', urlRoom: '26', urlOrgID: null };
        if (id === 23) return { urlId: '11', urlRoom: '23', urlOrgID: null };
        if (id === 24) return { urlId: '11', urlRoom: '24', urlOrgID: null };
        if (id === 25) return { urlId: '11', urlRoom: '25', urlOrgID: null };
        if (id === 26) return { urlId: '11', urlRoom: '26', urlOrgID: null };
        return { urlId: Number(rowData.device_group) === 1 ? '101' : '100', urlRoom: String(rowData.id), urlOrgID: null };
    };

    /** Jedinečná URL pro tento display/kiosk. Pro Holiday Inn stejné URL jako v Users/Displays (podle url_id / popisu). */
    const buildRuntimeUrl = (extraParams = {}) => {
        const orgId = (props.data.cOrganization_id || '').toString().trim().toUpperCase();
        const isHolidayInn = orgId === HOLIDAY_INN_ORG_ID.toUpperCase();
        const isRadissonBlu = orgId === RADISSON_BLU_ORG_ID.toUpperCase();
        const dg = Number(props.data.device_group);
        // Stejná logika jako Row_display: room = url_room ?? roomGroup ?? device.id (reálná URL např. room=41)
        const roomVal = props.data.url_room != null && props.data.url_room !== '' ? String(props.data.url_room) : (props.data.roomGroup ?? props.data.room_group);
        const room = roomVal != null && roomVal !== '' ? String(roomVal) : String(props.data.id);

        if (isHolidayInn) {
            const base = getDisplayBaseUrl(false);
            const { urlId, urlRoom, urlOrgID } = getHolidayInnUrlParams(props.data);
            const params = new URLSearchParams();
            params.set('id', urlId);
            if (urlRoom) params.set('room', urlRoom);
            if (urlOrgID) params.set('orgID', urlOrgID);
            let url = `${base}?${params.toString()}`;
            if (extraParams.demoRatio) url += `&demoRatio=${encodeURIComponent(extraParams.demoRatio)}`;
            return url;
        }
        if (isRadissonBlu) {
            const base = getDisplayBaseUrl(true);
            const id = dg === 1 ? '5' : '7';
            if (dg === 2) {
                let url = `${base}?id=${id}`;
                if (extraParams.demoRatio) url += `&demoRatio=${encodeURIComponent(extraParams.demoRatio)}`;
                return url;
            }
            let url = `${base}?id=${id}&room=${room}`;
            if (extraParams.demoRatio) url += `&demoRatio=${encodeURIComponent(extraParams.demoRatio)}`;
            return url;
        }
        // Vienna House (Plzeň): v admin listu chceme vždy /admin/?id=6&kiosk=2 (hall i 1st floor)
        const isViennaHouse = orgId === VIENNA_HOUSE_ORG_ID.toUpperCase();
        if (isViennaHouse && dg === 2) {
            const base = getDisplayBaseUrl(true);
            let url = `${base}?id=6&kiosk=2`;
            if (extraParams.demoRatio) url += `&demoRatio=${encodeURIComponent(extraParams.demoRatio)}`;
            return url;
        }

        const base = getDisplayBaseUrl(true);
        const has = (v) => v != null && v !== '';
        const idParam = has(props.data.url_id) ? String(props.data.url_id) : (dg === 1 ? '101' : '100');
        const params = new URLSearchParams({
            room,
            orgID: String(props.data.cOrganization_id),
            id: idParam
        });
        if (extraParams.demoRatio) params.set('demoRatio', extraParams.demoRatio);
        return `${base}?${params.toString()}`;
    };

    const copy = async () => {
        await copyToClipboard(buildRuntimeUrl());
    };

    const openDemo = () => setDemoOpen(true);

    // Při otevření dema načíst poměr stran z nastavení zařízení (9:16 / 16:9 / 4:3)
    useEffect(() => {
        if (!demoOpen || !data?.id) return;
        const deviceGroup = Number(data?.device_group);
        
        // Pro displeje (device_group === 1) vždy použít 4:3, bez ohledu na nastavení
        if (deviceGroup === 1) {
            setDemoRatio('4:3');
            return;
        }
        
        // Pro kiosky načíst z nastavení nebo použít podle orientation
        let cancelled = false;
        const load = async () => {
            try {
                const resp = await axios.get(`${path}/getDeviceSettings/${data.id}`);
                const r = resp.data?.settings?.demoRatio;
                if (cancelled) return;
                if (typeof r === 'string' && RATIO_OPTIONS.includes(r)) {
                    setDemoRatio(r);
                } else {
                    // Fallback podle orientation: landscape = 16:9, portrait = 9:16
                    if (Number(data?.orientation) === 2) {
                        setDemoRatio('16:9'); // Kiosk landscape
                    } else {
                        setDemoRatio('9:16'); // Kiosk portrait
                    }
                }
            } catch (_) {
                if (!cancelled) {
                    // Fallback při chybě: podle orientation
                    setDemoRatio(Number(data?.orientation) === 2 ? '16:9' : '9:16');
                }
            }
        };
        load();
        return () => { cancelled = true; };
    }, [demoOpen, data?.id, data?.orientation, data?.device_group]);

    useEffect(() => {
        if (!demoOpen) return;
        const vw = typeof window !== 'undefined' ? window.innerWidth : 0;
        const vh = typeof window !== 'undefined' ? window.innerHeight : 0;
        const expectedWidth = isPortrait(demoRatio) ? (vh * 0.95 * 9 / 16) : demoRatio === '16:9' ? Math.min(vw * 0.95, vh * 0.95 * 16 / 9) : Math.min(vw * 0.95, vh * 0.95 * 4 / 3);
        console.log('[Kiosk Demo – admin Zobrazovače]', {
            demoRatio: demoRatio || '(nevybráno)',
            url: buildRuntimeUrl({ demoRatio }),
            viewport: `${vw}×${vh}`,
            očekávanéRozlišeníKontejneru: `${Math.round(expectedWidth)}×${Math.round(vh * 0.95)}`,
        });
    }, [demoOpen, demoRatio]);

    const colCount = props.showOrg ? 4 : 3;
    const cellDataCls = (i, isAct) => {
        const isFirst = i === 0;
        const isLast = i === colCount - 1;
        return `${classes.cellData} ${isFirst ? classes.cellColFirst : ''} ${isLast ? classes.cellColLast : ''} ${props.isLastRow ? classes.cellRowLast : ''} ${isAct ? classes.columnAct : classes.column}`;
    };

    const actButtons = (
        <>
            <Button onClick={editFn} color="primary" variant="outlined">Upravit</Button>
            <Tooltip title={buildRuntimeUrl()} placement="top">
                <span><Button onClick={()=>copy()} color="primary" variant="outlined">URL</Button></span>
            </Tooltip>
            <Button onClick={()=>deleteFn()} color="primary" variant="outlined">Odstranit</Button>
        </>
    );

    const rowContent = props.renderAsGridRow ? (
        <div style={{ display: 'contents' }}>
            {props.showOrg && <div className={cellDataCls(0, false)}>{data.organizationName || data.cOrganization_id || '—'}</div>}
            <div className={cellDataCls(props.showOrg ? 1 : 0, false)}>{data.description}</div>
            <div className={cellDataCls(props.showOrg ? 2 : 1, false)}>{data.device_group == 1 ? "Displej" : "Kiosk"}</div>
            <div className={cellDataCls(colCount - 1, true)}>{actButtons}</div>
        </div>
    ) : (
        <div className={classes.columns} style={props.gridColumns ? { gridTemplateColumns: props.gridColumns } : (props.showOrg ? { gridTemplateColumns: 'minmax(0, 1fr) minmax(0, 1fr) minmax(0, 1fr) minmax(200px, auto)' } : undefined)}>
            {props.showOrg && <div className={classes.column}>{data.organizationName || data.cOrganization_id || '—'}</div>}
            <div className={classes.column}>{data.description}</div>
            <div className={classes.column}>{data.device_group == 1 ? "Displej" : "Kiosk"}</div>
            <div className={classes.columnAct}>{actButtons}</div>
        </div>
    );

    return <>
    {rowContent}

    <Dialog
        open={demoOpen}
        onClose={() => setDemoOpen(false)}
        maxWidth={false}
        PaperProps={{
            sx: {
                borderRadius: '12px',
                maxHeight: '95vh',
                overflow: 'hidden'
            }
        }}
    >
        <DialogContent
            sx={{
                p: 0,
                position: 'relative',
                backgroundColor: '#111',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                minHeight: 320,
                overflow: 'hidden'
            }}
        >
            <IconButton
                aria-label="close"
                onClick={() => setDemoOpen(false)}
                sx={{
                    position: 'absolute',
                    right: 8,
                    top: 8,
                    color: 'white',
                    backgroundColor: 'rgba(0, 0, 0, 0.5)',
                    zIndex: 1,
                    '&:hover': { backgroundColor: 'rgba(0, 0, 0, 0.7)' }
                }}
            >
                <CloseIcon />
            </IconButton>
            <Box
                sx={{
                    aspectRatio: demoRatio === '9:16' ? '9/16' : demoRatio === '16:9' ? '16/9' : '4/3',
                    boxSizing: 'border-box',
                    flexShrink: 0,
                    height: '95vh',
                    ...(isPortrait(demoRatio)
                        ? { width: 'calc(95vh * 9 / 16)' }
                        : demoRatio === '16:9'
                            ? { width: 'min(100%, calc(95vh * 16 / 9))' }
                            : { width: 'min(100%, calc(95vh * 4 / 3))' }
                    )
                }}
            >
                <iframe
                    title={`Demo ${data.description || data.id}`}
                    src={buildRuntimeUrl({ demoRatio })}
                    key={`${buildRuntimeUrl({ demoRatio })}`}
                    allow="fullscreen"
                    allowFullScreen
                    style={{ width: '100%', height: '100%', border: 0, display: 'block' }}
                />
            </Box>
        </DialogContent>
    </Dialog>
    </>
}
export default Row_org_device;